export const FileTypes = {
	CSV: "csv",
	EXCEL: "xlsx"
};